/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentDto } from '../../models/consultation-content-dto';
import { ConsultationContentUpdateDto } from '../../models/consultation-content-update-dto';

export interface ConsultationContentAdminControllerUpdateV1$Params {
  id: string;
      body: ConsultationContentUpdateDto
}

export function consultationContentAdminControllerUpdateV1(http: HttpClient, rootUrl: string, params: ConsultationContentAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
  const rb = new RequestBuilder(rootUrl, consultationContentAdminControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationContentDto>;
    })
  );
}

consultationContentAdminControllerUpdateV1.PATH = '/api/v1/consultation-contents/admin/{id}';
